export interface TicketCountModel {
  critical: number;
  major: number;
  minor: number;
  total?: number;
}
